import styled from 'styled-components';

export const InputContainer = styled.div`
    /* position: relative; */
    width: 100%;
    height: 72px;
`;

interface InputProps {
    errors: any;
}

export const Input = styled.input<InputProps>`
    border: ${props => props.errors ? '1px solid red !important' : '1px solid #8C8C8C'};

    /*width: 100%;
    height: 40px;
    padding: 0 10px;
    border: 1px solid #d3d3d3;
    outline: 0;
    border-radius: 5px; */
`;

export const ErrorMessage = styled.span`
    color: #E81B1B;
    font-weight: 300px;
    line-height: 16px;
    font-size: 1rem;
    display: block;
    margin: 0;
    margin-top: 8px;
`;